'use client';

import { useSuspenseQuery } from '@apollo/client';
import {
    GET_CLIENT_SHOW_GROUPS_ON_DASHBOARD_FOR_CLIENT,
    GetClientShowGroupsOnDashboardForClientQuery,
    GetClientShowGroupsOnDashboardForClientQueryVariables,
} from '@deltasierra/frontend-graphql-core';
import { AppFrontendRoutes } from '@deltasierra/frontend-routing-app-frontend';
import { QueryParameter } from '@deltasierra/frontend-routing-core';
import { useAppFrontendRouter } from '@deltasierra/react-hooks-routing';
import { redirect } from 'next/navigation';
import { ReactNode } from 'react';
import { useCrossPlatform } from '../../../hooks/useCrossPlatform';
import { usePageLocationContext } from '../../../hooks/usePageLocationContext';

function RedirectToDashboard(): ReactNode {
    const contextResult = usePageLocationContext();

    const { data } = useSuspenseQuery<
        GetClientShowGroupsOnDashboardForClientQuery,
        GetClientShowGroupsOnDashboardForClientQueryVariables
    >(GET_CLIENT_SHOW_GROUPS_ON_DASHBOARD_FOR_CLIENT, {
        variables: { clientId: contextResult?.location?.clientId ?? '' },
    });

    if (!data) {
        return <></>;
    }

    if (data?.client?.showGroupsOnDashboard) {
        return redirect('/dashboard/brands');
    }

    return redirect('/dashboard');
}

export default function HomePage(): ReactNode {
    const contextResult = usePageLocationContext();
    const { isRunningOnMobileApp } = useCrossPlatform();
    const appFrontendRouter = useAppFrontendRouter();

    if (isRunningOnMobileApp) {
        return redirect(
            appFrontendRouter.getRoute(AppFrontendRoutes.Templates, {
                [QueryParameter.ClientId]: contextResult?.location?.clientId,
                [QueryParameter.LocationId]: contextResult?.location?.locationId,
            }),
        );
    }

    return <RedirectToDashboard />;
}
HomePage.displayName = 'HomePage';
